module.exports = __webpack_public_path__ + "static/media/scavenger-special.ec20af62.png";